import {post, get} from '@/lib/axios';

const feedback = {
  async get_feedback_questions() {
    return get(`/feedback`);
  },
  async post_feedback_questions(data) {
    return post(`/feedback`, data);
  },
};

export {feedback as default};
